<template>
<div class="chapter">
<div class="inner_page">
<p class="C127"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="C134"><a id="page_vii"><em></em></a><em><a href="#/xhtml/05_Acknowle#page_ix">Acknowledgments</a></em></p>
<p class="C129"><a href="#/xhtml/07_Introduc#page_1">Introduction: Moral Imperfection: An Ethics for Democracy</a></p>
<p class="C129"><span href="#/xhtml/08_1__After#page_29" title="Link target outside of Sample"><strong>1.</strong> After Virtue: The Strange Case of <em>Belle Époque</em> Socialist Antimaterialism</span></p>
<p class="C129"><span href="#/xhtml/09_2__On_De#page_55" title="Link target outside of Sample"><strong>2.</strong> On Descent: Stories from the Gurus of Modern India</span></p>
<p class="C129"><span href="#/xhtml/10_3__Eleme#page_93" title="Link target outside of Sample"><strong>3.</strong> Elementary Virtues: The Great War and the Crisis of European Man</span></p>
<p class="C129"><span href="#/xhtml/11_4__Incon#page_116" title="Link target outside of Sample"><strong>4.</strong> Inconsequence: Some Little-Known Mutinies Around 1946</span></p>
<p class="C134"><span href="#/xhtml/12_Epilogue#page_149" title="Link target outside of Sample">Epilogue: Paths of Ahimsaic Historiography</span></p>
<p class="C129"><em><span href="#/xhtml/13_Notes#page_167" title="Link target outside of Sample">Notes</span></em></p>
<p class="C129"><em><span href="#/xhtml/14_Index#page_229" title="Link target outside of Sample">Index</span></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?7559c392